import { ExpertBio, mapContentToExpertBio } from "#/components/read/shared/ExpertBioMapper"
import { Asset } from "contentful"
import { TypeGroupSessionSkeleton } from "#/types/contentful"
import { RawContentfulConditionSkeleton } from "#/lib/contentful/utils/conditionUtils"
import { EntryWithoutUnresolvableLinks } from "#/utils/ContentTypes"
import { TimeTapEnvironment } from "../../../components/time-tap/TimeTapScheduler"

export type File = {
  url: string
}
export type Thumbnail = {
  file: File
}

export type Group = {
  id: string
  thumbnail: Thumbnail
  title: string
  slug: string
  overview: string
  description: string
  topics: string
  conditions: EntryWithoutUnresolvableLinks<RawContentfulConditionSkeleton>[]
  moderators: ExpertBio[]
  reasonId: number
  locationId?: number
  timeTapEnvironment?: TimeTapEnvironment
}

const mapContentToThumbnail = ({ fields }: Asset<"WITHOUT_UNRESOLVABLE_LINKS">): Thumbnail => {
  if (!fields) {
    return null
  }
  const { file } = fields
  return {
    file
  }
}

export const mapContentToGroup = ({ fields, sys }: EntryWithoutUnresolvableLinks<TypeGroupSessionSkeleton>): Group => {
  if (!fields || !sys) {
    return null
  }
  const {
    slug,
    title,
    description,
    conditions,
    overview,
    topics,
    thumbnail,
    moderators,
    reasonId,
    locationId,
    timeTapEnvironment
  } = fields
  const { id } = sys
  return {
    id,
    title,
    slug,
    description,
    conditions,
    overview,
    topics,
    reasonId,
    locationId,
    timeTapEnvironment,
    thumbnail: thumbnail && mapContentToThumbnail(thumbnail),
    moderators: moderators?.map(mapContentToExpertBio)
  }
}
